import { render, staticRenderFns } from "./ButtonNew.vue?vue&type=template&id=394fd479"
import script from "./ButtonNew.vue?vue&type=script&lang=js"
export * from "./ButtonNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports